import React from 'react';

interface Props {
  className?: string;
}

const Star: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 19"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 -0.00965881L13.2132 6.08247L20 7.25632L15.1969 12.1932L16.1776 19.0097L10 15.971L3.81872 19.0097L4.79941 12.1932L0 7.25632L6.78306 6.08247L10 -0.00965881Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Star;
